module.exports = __webpack_public_path__ + "img/logo.36240e92.jpeg";